
export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function SortArray(x: any, y: any){
  if (x.text.toUpperCase() < y.text.toUpperCase()) {return -1;}
  if (x.text.toUpperCase() > y.text.toUpperCase()) {return 1;}
  return 0;
}

export function formatDate(date: string) {
  const options = {
    weekday: 'long',
    month: 'short',
    year: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  return new Date(date).toLocaleDateString('en-us', options);
}
